import { type FC, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import type { EmailBlockTypeType } from "@/types/graphql/partner.generated";
import {
  BLOCK_TYPE_LABEL_KEYS,
  BLOCK_TYPES,
  EDITABLE_BLOCK_TYPES,
  EMAIL_TEMPLATE_LIMITS,
} from "../model/blocks";

interface AddBlockMenuProps {
  blocksCount: number;
  onAdd: (type: EmailBlockTypeType) => void;
}

/**
 * «Добавить блок»: меню всех типов блоков. Тип без формы в BlockEditor
 * (не входит в EDITABLE_BLOCK_TYPES) показывается неактивным.
 */
export const AddBlockMenu: FC<AddBlockMenuProps> = ({ blocksCount, onAdd }) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        startIcon={<AddIcon />}
        onClick={(event) => setAnchor(event.currentTarget)}
        disabled={blocksCount >= EMAIL_TEMPLATE_LIMITS.blocksPerVariant}
        sx={{ alignSelf: "flex-start" }}
      >
        {t("emailTemplates.blocks.add")}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        {BLOCK_TYPES.map((type) => (
          <MenuItem
            key={type}
            disabled={!EDITABLE_BLOCK_TYPES.has(type)}
            onClick={() => {
              setAnchor(null);
              onAdd(type);
            }}
          >
            {t(BLOCK_TYPE_LABEL_KEYS[type])}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
